<template>
    <ui-dropdown :placement="placement" menu-class="w-96" :trigger-class="triggerClass">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-5 pt-3">

                <!-- Confirming price update. -->
                <div>
                    <div class="text-xs font-medium text-gray-400 mb-4">Update price</div>
                    <p class="mt-4 text-sm">
                        Updating the price will update all instances of this material in this estimate.
                        It will affect <strong>{{ materialSpec.spec_usages.length }} specs</strong>
                        used in <strong>{{ materialSpec.item_usages.length }} different items</strong>.
                    </p>
                    <p class="mt-4 text-sm">
                        The new price for the material will be <strong>{{ newPriceFormatted }}</strong><span v-if="true"> which will be <strong>a price agreement</strong></span>.
                    </p>
                    <p class="mt-4 text-sm">Are you sure you want to continue?</p>
                    <div class="mt-6 flex justify-end space-x-6">
                        <ui-button-new @click.stop.prevent="close">Cancel</ui-button-new>
                        <ui-button-new warning @click.stop.prevent="updatePrice(close)">
                            Yes, update the price
                        </ui-button-new>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import { estimateStore } from '@stores'
import { debounce } from 'lodash'
import { toCurrency, asRoundedNumber } from '@utils'

export default {
    props: {
        materialSpec: Object,
        triggerClass: String,
        alignRight: Boolean,
    },
    data () {
        return {
            newPrice: this.materialSpec.price_per_item
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return estimateStore.state.estimate
        },
        newPriceFormatted () {
            return toCurrency(asRoundedNumber(this.newPrice))
        },
        placement () {
            return this.alignRight ? 'bottom-end' : 'bottom-start'
        },
    },
    methods: {
        scope (dropdownScope) {
            let that = this

            return {
                inputValue: this.materialSpec.price_per_item,
                inputListener: function(newPrice){
                  that.newPrice = newPrice

                  if (parseFloat(that.materialSpec.price_per_item) !== parseFloat(newPrice)) {
                      dropdownScope.open()
                  }
                },
                setNewPrice: newPrice => {
                    this.newPrice = newPrice
                },
                ...dropdownScope,
            }
        },
        updatePrice (close = ()=>{}) {
            this.$emit('updated', this.newPrice)
            close()
        },
    },
}
</script>
